<template>
  <section class="flex flex-col min-h-screen">
    <div class="min-h-screen bg-gray-100">
      <div class="container mx-auto px-4">
        <!-- Başlık -->
        <PageHeader> İletişim </PageHeader>

        <!-- Harita -->
        <div class="mb-8">
          <iframe
            :src="mapSrc"
            width="100%"
            height="450"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </div>

        <!-- İçerik -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          <!-- Sol Taraf: Şirket Bilgileri -->
          <div class="bg-white p-6 rounded-lg shadow-md">
            <h2 class="text-2xl font-bold mb-4">{{ company.Name }}</h2>
            <p class="text-gray-700 mb-2">{{ company.Address }}</p>
            <p class="text-gray-700 mb-2">Telefon: {{ company.Phone }}</p>
            <p class="text-gray-700">Email: {{ company.Email }}</p>
          </div>

          <!-- Sağ Taraf: İletişim Formu -->
          <div class="bg-white p-6 rounded-lg shadow-md">
            <h2 class="text-2xl font-bold mb-4">İletişim Formu</h2>
            <form @submit.prevent="submitForm">
              <div class="mb-4">
                <label for="name" class="block text-gray-700">Adınız</label>
                <input
                  type="text"
                  id="name"
                  v-model="form.name"
                  class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div class="mb-4">
                <label for="email" class="block text-gray-700">Email</label>
                <input
                  type="email"
                  id="email"
                  v-model="form.email"
                  class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div class="mb-4">
                <label for="phone" class="block text-gray-700">Telefon</label>
                <input
                  type="text"
                  id="phone"
                  v-model="form.phone"
                  class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div class="mb-4">
                <label for="message" class="block text-gray-700"
                  >Mesajınız</label
                >
                <textarea
                  id="message"
                  v-model="form.message"
                  rows="4"
                  class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                class="w-full bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition duration-300"
              >
                Gönder
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import PageHeader from "@/components/LandingLayout/landing-compoments/PageHeader.vue";
import { getContactInfo, submitContactForm } from "@/services/contentService";
import { Toast } from "@/services/toastService";

// JSON verisi API'den geliyor gibi simüle ediyoruz
const company = ref({});

// Harita için reactive state
const map = ref({});

const mapSrc = computed(() => {
  const latitude = Number(map.value?.Latitude);
  const longitude = Number(map.value?.Longitude);
  const zoom = Number(map.value?.Zoom) || 16;

  if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
    return "https://maps.google.com/maps?q=38.714413750130824,35.53253173828126&z=16&output=embed";
  }

  return `https://maps.google.com/maps?q=${latitude},${longitude}&z=${zoom}&output=embed`;
});

// İletişim formu için reactive state
const form = ref({
  name: "",
  email: "",
  phone: "",
  message: "",
});

const submitForm = () => {
  submitContactForm(form.value).then((response) => {
    if (response) {
      Toast(
        "Başarılı",
        " Mesajınız başarıyla gönderildi.",
        "success",
        null,
        null,
        false
      );
    } else {
      Toast(
        "Hata",
        " Mesajınız gönderilirken bir hata oluştu.",
        "error",
        null,
        null,
        false
      );
    }
  });
};

onMounted(() => {
  // API'den iletişim bilgilerini alıyoruz
  getContactInfo().then((response) => {
    company.value = response.Company;
    map.value = response.Map;
  });
});
</script>

<style scoped>
/* Ekstra stil ihtiyaçları için buraya CSS ekleyebilirsiniz */
</style>
